import axios from 'axios'
import { REACT_APP_BFF_NODE } from '../../../../config'
import { getUserToken } from '../../../../utils/functions/getUserToken'

export const apiBffMobileV1PaymentMethods = axios.create({
  baseURL: `${REACT_APP_BFF_NODE}/v1/paymentmethods`,
  headers: {
    Authorization: `Bearer ${getUserToken()}`,
  },
})
